import { usePageMeta } from "../usePageMeta";
import ApiKeys from "../components/ApiKeys";
import AppLayout from "../layout";

export default function ApiKeysPage() {
  usePageMeta({
    title: "Dashboard | Generate GIF API Keys",
    description: "Create and Manage Your KLIPY GIF API Keys.",
    ogTitle: "Generate GIF API Keys",
    ogDescription: "Create and Manage Your KLIPY GIF API Keys.",
    ogImage: "https://partner.klipy.com/images/klipy-api-banner-v2.png",
    ogUrl: "https://partner.klipy.com/api-keys",
    canonicalUrl: "https://partner.klipy.com/api-keys",

    twitterTitle: "Dashboard | Generate GIF API Keys",
    twitterDescription:
      "Create and Manage Your KLIPY GIF API Keys.",
    twitterImage: "https://partner.klipy.com/images/klipy-api-banner-v2.png",
  });

  return (
    <AppLayout>
      <ApiKeys />
    </AppLayout>
  );
}
